module.exports = __webpack_public_path__ + "static/img/p17.c1522fa8.png";